export const Resources = ({
  children,
  resourceList,
}: {
  children: React.ReactNode;
  resourceList: Array<{ title: string; url: string; type?: string }>;
}) => {
  return (
    <div className="flex flex-col gap-2 shadow-xs rounded-lg border border-neutral-200 p-2">
      <div className="p-3 bg-[#4665B0]/10 rounded-lg text-neutral-900">
        {children}
      </div>
      <div className="flex flex-col">
        {resourceList.map((resource, index) => (
          <a
            href={
              resource.type?.toLowerCase() === "blog"
                ? `${resource.url}`
                : resource.url
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              key={index}
              className="border-b border-neutral-200 p-3 hover:bg-neutral-100 rounded-lg"
            >
              {resource.title}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
